var map = {
	"./404-bg.png": 5667,
	"./404.png": 9411,
	"./BNB.png": 8145,
	"./ETH.png": 6594,
	"./airtel.png": 4440,
	"./arrow-left.png": 3052,
	"./arrow-right.png": 1961,
	"./banner-bonus.png": 4715,
	"./card-tick.png": 9947,
	"./card.png": 4697,
	"./chart.png": 9635,
	"./close-circle-red.png": 8584,
	"./close-circle.png": 7122,
	"./coin.png": 5444,
	"./comingsoon.png": 5019,
	"./down-arrow-white.png": 6379,
	"./down-arrow.png": 5979,
	"./eth.png": 3586,
	"./exchange.png": 6708,
	"./eye.png": 9988,
	"./globalchartval.png": 5619,
	"./grid.png": 2635,
	"./grn-sqr.png": 9517,
	"./kkogbg.png": 5902,
	"./kkogcoin-mini.png": 730,
	"./kkogcoin.png": 8176,
	"./left-line.png": 113,
	"./line.png": 2933,
	"./logo.png": 2806,
	"./medichartval.png": 9829,
	"./metamask.png": 3168,
	"./money-recive.png": 9182,
	"./money.png": 7703,
	"./mpesa.png": 4955,
	"./mtn.png": 6316,
	"./piechart.png": 8417,
	"./profile-circle.png": 2367,
	"./swap.png": 7626,
	"./tick-circle.png": 1863,
	"./toggle.png": 2711,
	"./trust.png": 2605,
	"./wallet.png": 9492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4504;